import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
export { Fieldset } from './fieldset/index.js';
export { Checkbox, Input, InputRadio, Label, OptionInput, Required, Select, baseInputStyles, errorInputStyles, requiredStyles } from './formstyles.js';
import 'react';
import '../alert/index.js';
import 'react/jsx-runtime';
import './option/index.js';
export { SelectField } from './select/index.js';
export { Legend } from './legend/index.js';
export { DateOfBirth } from './dob/index.js';
export { DateField } from './date/index.js';
import 'libphonenumber-js';
export { HelpText } from './helptext/index.js';
export { Switch } from './switch/index.js';

var _templateObject;
const Form = /*#__PURE__*/styled.form.withConfig({
  displayName: "form__Form",
  componentId: "sc-16o89n1-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  row-gap: ", ";\n  margin: 0;\n  padding: 0;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.baseSpacing;
});

export { Form };
